<template>
  <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
    <div class="card-header">
      <h5>{{ distribution.note_ref }}</h5>
      <br />
      <p>
        Date de création :
        <b v-if="distribution.created_at">
          {{ getDate(distribution.created_at) }}</b
        >
        | <b> {{ distribution.zone_name }} </b> |
        <b>{{ distribution.note_city }} </b> |
        <b>{{ distribution.note_delivery_name }} </b>
      </p>
    </div>
  </div>

  <div
    class="card mb-25 border-0 rounded-0 bg-white letter-spacing"
    v-if="distribution.note_save == 0 && auth.can('BDIS')"
  >
    <div class="card-header">
      <h5>Scan code suivi</h5>
    </div>
    <div class="card-body p-15 p-sm-20 p-md-25">
      <form v-on:submit.prevent="SearchColis">
        <div class="custom-search">
          <div class="row">
            <div class="col-md-8">
              <div class="form-group">
                <label>Code Suivi :</label>
                <input
                  placeholder="Code Suivi"
                  type="text"
                  id="scanFocus"
                  v-model="codeColis"
                  class="form-control"
                />
              </div>
            </div>
            <div class="col-md-4">
              <button class="btn btn-success me-3 mb-3 mt-3" type="submit">
                <i class="ph ph-scan"></i>
              </button>
            </div>
            <div class="col-12">
              <hr />
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>

  <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
    <div class="card-header">
      <h5>List des nouveaux colis</h5>
    </div>

    <div
      class="card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25"
    >
      <div class="d-sm-flex align-items-center">
        <button
          class="default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-success fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0"
          type="button"
          v-if="auth.can('ADD_BDIS')"
          @click="addNewColis"
          :disabled="load_add"
        >
          <template v-if="load_add">
            <div class="spinner-border text-white" role="status">
              <span class="visually-hidden">Loading...</span>
            </div>
          </template>
          Ajouter
          <i class="flaticon-plus position-relative ms-5 fs-12"></i>
        </button>
      </div>
      <div class="d-flex align-items-center">
        <input
          type="text"
          @input="getRows1()"
          v-model="users1.searchTerm"
          class="form-control shadow-none text-black rounded-0"
          placeholder="Chercher"
        />
      </div>
    </div>

    <div class="card-body p-15 p-sm-20 p-md-25">
      <div class="row mb-20">
        <template v-if="auth.can('FILTER_IN_DISTRIBUTION')">
          <div class="col-md-4 mb-10">
            <b-form-group>
              <label>Status:</label>
              <v-select
                class="custom-select-height"
                v-model="status_filter"
                label="name"
                :options="StatusList"
              >
                <!-- @search="onSearchStatus" -->
              </v-select>
            </b-form-group>
          </div>
          <div class="col-md-4 mb-10">
            <b-form-group>
              <label>Livreur:</label>
              <v-select
                class="custom-select-height"
                v-model="liv_filter"
                label="name"
                :options="LivreurList"
              >
                <!-- <template slot="no-options">
                        Taper un mot pour chercher un livreur
                      </template> -->
              </v-select>
            </b-form-group>
          </div>
          <div class="col-md-4 mb-10">
            <button
              style="margin-top: 22px"
              class="btn btn-primary"
              @click="searchFilter()"
            >
              <i class="flaticon-search"></i>
              Chercher
            </button>
            <button
              style="margin-top: 22px"
              class="btn btn-warning"
              @click="removeFilter()"
            >
              <i class="flaticon-close"></i>
              Annuler
            </button>
          </div>
        </template>
        <div
          class="col-md-6 d-flex align-items-center justify-content-start mb-1 mb-md-0"
        >
          <label>Voir</label>
          <v-select
            v-model="users1.per_page"
            :options="[10, 50]"
            :clearable="false"
            class="per-page-selector d-inline-block mx-50"
            @input="getRows1()"
          />
          <label>{{ users1.total }} entités</label>
        </div>
      </div>

      <vue-good-table
        :columns="columns"
        :rows="rows1"
        :select-options="{
          enabled: true,
          clearSelectionText: 'Annuler',
          selectionText: 'colis Sélectionnés',
        }"
        @selected-rows-change="selectionChanged"
        @select-all="onSelectAll"
      >
        <!-- <div slot="emptystate"></div> -->
        <template #emptystate>
          <center>Aucune entrées correspondants trouvés</center>
        </template>
        <template #table-row="props">
          <template v-if="props.column.field === 'code'">
            <h6 class="text-warning" v-if="props.row.replace == 1">
              {{ props.row.code }}
              <i class="flaticon-refresh"></i>
            </h6>
            <h6 class="text-info" v-else-if="props.row.partial == 1">
              {{ props.row.code }}
              <i class="flaticon-corner-down-left"></i>
            </h6>
            <h6 v-else>
              {{ props.row.code }}
            </h6>
          </template>
          <template v-else-if="props.column.field === 'status'">
            <div
              v-if="
                props.row.status == 'IN_PROGRESS' &&
                props.row.status_second &&
                globalStore.globalHelper(props.row.status_second).name
              "
              class="rounded-pill fs-13 badge text-bg-black custom-badge"
              :style="{
                '--dynamic-bg': globalStore.globalHelper(
                  props.row.status_second
                ).code_color,
              }"
            >
              {{ globalStore.globalHelper(props.row.status_second).name }}
            </div>
            <div
              v-else
              class="rounded-pill fs-13 badge text-bg-black custom-badge"
              :style="{ '--dynamic-bg': props.row.code_color }"
            >
              {{ props.row.s_name }}
            </div>
          </template>

          <template v-else-if="props.column.field === 'price'">
            <b>{{ props.row.price }}</b> DH
          </template>
          <template v-else-if="props.column.field === 'updated_at'">
            <span class="text-nowrap">
              {{ getDate(props.row.updated_at) }}
            </span>
          </template>
          <span v-else>
            {{ props.formattedRow[props.column.field] }}
          </span>
        </template>

        <template #pagination-bottom="props">
          <div class="d-flex justify-content-between flex-wrap">
            <!-- Left side: per page selector -->
            <div class="d-flex align-items-center mb-0 mt-1">
              <span class="text-nowrap">Voir</span>

              <select
                v-model="pageLength"
                class="form-select mx-1"
                style="width: auto"
                @change="
                  (e) =>
                    props.perPageChanged({
                      currentPerPage: parseInt(e.target.value),
                    })
                "
              >
                <option
                  v-for="opt in [10, 25, 50, 100]"
                  :key="opt"
                  :value="opt"
                >
                  {{ opt }}
                </option>
              </select>

              <span class="text-nowrap"> de {{ props.total }} entités </span>
            </div>

            <!-- Right side: pagination -->
            <nav>
              <ul class="pagination mt-1 mb-0">
                <li
                  class="page-item"
                  :class="{ disabled: props.currentPage === 1 }"
                >
                  <button
                    class="page-link"
                    @click="
                      props.pageChanged({ currentPage: props.currentPage - 1 })
                    "
                  >
                    <feather-icon icon="ChevronLeftIcon" size="18" />
                  </button>
                </li>

                <li
                  v-for="page in Math.ceil(props.total / pageLength)"
                  :key="page"
                  class="page-item"
                  :class="{ active: props.currentPage === page }"
                >
                  <button
                    class="page-link"
                    @click="props.pageChanged({ currentPage: page })"
                  >
                    {{ page }}
                  </button>
                </li>

                <li
                  class="page-item"
                  :class="{
                    disabled:
                      props.currentPage === Math.ceil(props.total / pageLength),
                  }"
                >
                  <button
                    class="page-link"
                    @click="
                      props.pageChanged({ currentPage: props.currentPage + 1 })
                    "
                  >
                    <feather-icon icon="ChevronRightIcon" size="18" />
                  </button>
                </li>
              </ul>
            </nav>
          </div>
        </template>
      </vue-good-table>
    </div>
  </div>

  <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
    <div class="card-header">
      <h5>Liste des colis ajoutés</h5>
    </div>
    <div
      class="card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25"
    >
      <div class="d-sm-flex align-items-center">
        <button
          class="default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-danger fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0"
          type="button"
          v-if="auth.can('ADD_BDIS')"
          @click="removeNewColis"
          :disabled="load_remove"
        >
          <template v-if="load_remove">
            <div class="spinner-border text-white" role="status">
              <span class="visually-hidden">Loading...</span>
            </div>
          </template>
          Supprimer
          <i class="flaticon-delete position-relative ms-5 fs-12"></i>
        </button>
      </div>
      <div class="d-flex align-items-center">
        <input
          type="text"
          @input="getRows2()"
          v-model="users2.searchTerm"
          class="form-control shadow-none text-black rounded-0"
          placeholder="Chercher"
        />
      </div>
    </div>
    <div class="card-body p-15 p-sm-20 p-md-25">
      <div class="row mb-20">
        <div
          class="col-md-6 d-flex align-items-center justify-content-start mb-1 mb-md-0"
        >
          <label>Voir</label>
          <v-select
            v-model="users2.per_page"
            :options="[10, 50]"
            :clearable="false"
            class="per-page-selector d-inline-block mx-50"
            @input="getRows2()"
          />
          <label>{{ users2.total }} entités</label>
        </div>
      </div>
      <vue-good-table
        :columns="columns2"
        :rows="rows2"
        :select-options="{
          enabled: true,
          clearSelectionText: 'Annuler',
          selectionText: 'Colis sélectionnés',
        }"
        @select-all="onSelectAllColis"
        @selected-rows-change="selectionChangedColis"
      >
        <!-- <div slot="emptystate"></div> -->
        <template #emptystate>
          <center>Aucune entrées correspondants trouvés</center>
        </template>
        <template #table-row="props">
          <template v-if="props.column.field === 'code'">
            <h6 class="text-warning" v-if="props.row.replace == 1">
              {{ props.row.code }}
              <i class="flaticon-refresh"></i>
            </h6>
            <h6 class="text-info" v-else-if="props.row.partial == 1">
              {{ props.row.code }}
              <i class="flaticon-corner-down-left"></i>
            </h6>
            <h6 v-else>
              {{ props.row.code }}
            </h6>
          </template>
          <template v-else-if="props.column.field === 'c_statut'">
            <div
              v-if="
                props.row.status == 'IN_PROGRESS' &&
                props.row.status_second &&
                globalStore.globalHelper(props.row.status_second).name
              "
              class="rounded-pill fs-13 badge text-bg-black custom-badge"
              :style="{
                '--dynamic-bg': globalStore.globalHelper(
                  props.row.status_second
                ).code_color,
              }"
            >
              {{ globalStore.globalHelper(props.row.status_second).name }}
            </div>
            <div
              v-else
              class="rounded-pill fs-13 badge text-bg-black custom-badge"
              :style="{ '--dynamic-bg': props.row.code_color }"
            >
              {{ props.row.s_name }}
            </div>
          </template>
          <template v-else-if="props.column.field === 'received_time'">
            <span class="text-nowrap">
              {{ getDate(props.row.received_time) }}
            </span>
          </template>

          <span v-else>
            {{ props.formattedRow[props.column.field] }}
          </span>
        </template>
        <template #pagination-bottom="props">
          <div class="d-flex justify-content-between flex-wrap">
            <!-- Left side: per page selector -->
            <div class="d-flex align-items-center mb-0 mt-1">
              <span class="text-nowrap">Voir</span>

              <select
                v-model="pageLength"
                class="form-select mx-1"
                style="width: auto"
                @change="
                  (e) =>
                    props.perPageChanged({
                      currentPerPage: parseInt(e.target.value),
                    })
                "
              >
                <option
                  v-for="opt in [10, 25, 50, 100]"
                  :key="opt"
                  :value="opt"
                >
                  {{ opt }}
                </option>
              </select>

              <span class="text-nowrap"> de {{ props.total }} entités </span>
            </div>

            <!-- Right side: pagination -->
            <nav>
              <ul class="pagination mt-1 mb-0">
                <li
                  class="page-item"
                  :class="{ disabled: props.currentPage === 1 }"
                >
                  <button
                    class="page-link"
                    @click="
                      props.pageChanged({ currentPage: props.currentPage - 1 })
                    "
                  >
                    <feather-icon icon="ChevronLeftIcon" size="18" />
                  </button>
                </li>

                <li
                  v-for="page in Math.ceil(props.total / pageLength)"
                  :key="page"
                  class="page-item"
                  :class="{ active: props.currentPage === page }"
                >
                  <button
                    class="page-link"
                    @click="props.pageChanged({ currentPage: page })"
                  >
                    {{ page }}
                  </button>
                </li>

                <li
                  class="page-item"
                  :class="{
                    disabled:
                      props.currentPage === Math.ceil(props.total / pageLength),
                  }"
                >
                  <button
                    class="page-link"
                    @click="
                      props.pageChanged({ currentPage: props.currentPage + 1 })
                    "
                  >
                    <feather-icon icon="ChevronRightIcon" size="18" />
                  </button>
                </li>
              </ul>
            </nav>
          </div>
        </template>
      </vue-good-table>
    </div>
  </div>
</template>

<script  lang="ts">
import { ref, reactive, onMounted } from "vue";
import moment from "moment";
import api from "@/utils/axios";
import { useAppToast } from "@/composables/useAppToast";
import { useGlobalStore } from "@/stores/global";
import { useAuthStore } from "@/stores/auth";
import { useRoute } from "vue-router";

export default {
  name: "ShowEditBn",

  setup: () => {
    const route = useRoute();

    // State
    const isLoader = ref(true);
    const searchTerm1 = ref("");
    const searchTerm2 = ref("");
    const pageLength = ref(10);
    const pageLength2 = ref(10);

    const LivreurList = ref<any[]>([]);
    const liv_filter = reactive({ id: "", name: "" });
    const status_filter = reactive({ id: "", name: "", code: "" });
    const StatusList = ref<any[]>([]);

    const { showToast } = useAppToast();
    const auth = useAuthStore();
    const user = auth.user;

    const columns = [
      {
        label: "Code Suivi",
        field: "code",
      },
      {
        label: "Client",
        field: "customer_name",
      },
      {
        label: "Date de réception",
        field: "received_time",
      },
      {
        label: "Ville",
        field: "city_name",
      },
      {
        label: "Adresse",
        field: "address",
      },
      {
        label: "Commentaire",
        field: "note",
      },
      {
        label: "Prix",
        field: "price",
      },
      {
        label: "Statut",
        field: "status",
      },
    ];
    const columns2 = [
      {
        label: "Code Suivi",
        field: "code",
      },
      {
        label: "Client",
        field: "customer_name",
      },
      {
        label: "Date de réception",
        field: "received_time",
      },
      {
        label: "Ville",
        field: "city_name",
      },
      {
        label: "Adresse",
        field: "address",
      },
      {
        label: "Commentaire",
        field: "note",
      },
      {
        label: "Prix",
        field: "price",
      },
      {
        label: "Statut",
        field: "c_statut",
      },
    ];
    const load_add = ref(false);
    const load_remove = ref(false);

    const fields = [
      { key: "parcel_code", label: "Code d'envoi" },
      { key: "situation", label: "Etat" },
      { key: "s_name", label: "Status" },
      { key: "created_at", label: "Date", tdClass: "browserclass" },
      { key: "city_name", label: "Informations" },
      { key: "name", label: "Action par" },
    ];

    const selectedRows = ref<any[]>([]);
    const selectedNewRows = ref<any[]>([]);
    const codeColis = ref("");
    const refReception = ref("");
    const rows1 = ref<any[]>([]);
    const rows2 = ref<any[]>([]);
    const distribution = ref<any>({});
    const ColiDetails = ref<any>({});
    const city = reactive({ id: 0, name: null as string | null });
    const rowID = ref<number | null>(null);
    const row = ref<any>({});

    const globalStore = useGlobalStore();

    // Pagination state
    const users1 = reactive({
      searchTerm: "",
      total: 0,
      per_page: 10,
      from: 1,
      to: 0,
      current_page: 1,
      searchLiv: "",
      searchStatut: "",
    });
    const users2 = reactive({
      searchTerm: "",
      total: 0,
      per_page: 10,
      from: 1,
      to: 0,
      current_page: 1,
    });

    // Form state
    const form = reactive({
      id: 0,
      code: "",
      price: "",
      phone: "",
      delivered_fees: "",
      returned_fees: "",
      refused_fees: "",
      receiver: "",
      address: "",
      note: "",
    });

    // Helpers
    function getDate(value: string) {
      return moment.utc(String(value)).format("YYYY-MM-DD HH:mm");
    }

    function resolveUserStatusVariant(status: string) {
      if (status === "PICKED_UP") return "warning";
      if (status === "DELIVERED") return "success";
      if (status === "PAID") return "info";
      if (status === "NOT_PAID") return "danger";
      return "primary";
    }

    // Selection handlers
    function onSelectAll(params: any) {
      selectedRows.value = params.selectedRows;
    }
    function selectionChanged(params: any) {
      selectedRows.value = params.selectedRows;
    }
    function onSelectAllColis(params: any) {
      selectedNewRows.value = params.selectedRows;
    }
    function selectionChangedColis(params: any) {
      selectedNewRows.value = params.selectedRows;
    }

    // API calls
    async function getData() {
      isLoader.value = true;
      try {
        const res = await api.get(`/api/auth/show_bon_distr`, {
          params: {
            ref: Array.isArray(route.params.refNote)
              ? route.params.refNote[0]
              : String(route.params.refNote),
          },
        });
        distribution.value = res.data;
        await getRows1();
        await getRows2();
      } finally {
        isLoader.value = false;
      }
    }

    async function getRows1() {
      const res = await api.get(
        `/api/auth/ListColisToDistr?searchTerm=${users1.searchTerm}`,
        {
          params: {
            ref: Array.isArray(route.params.refNote)
              ? route.params.refNote[0]
              : String(route.params.refNote),
          },
        }
      );
      rows1.value = res.data;
      // Object.assign(users1, res.data.users);
    }

    async function getRows2() {
      const res = await api.get(
        `/api/auth/ListColiInDist?searchTerm=${users2.searchTerm}`,
        {
          params: {
            ref: Array.isArray(route.params.refNote)
              ? route.params.refNote[0]
              : String(route.params.refNote),
          },
        }
      );
      rows2.value = res.data;
      // Object.assign(users2, res.data.users);
    }

    async function SearchColis() {
      let data = new FormData();
      data.append(
        "note_ref",
        Array.isArray(route.params.refNote)
          ? route.params.refNote[0]
          : String(route.params.refNote)
      );
      data.append("code_colis", codeColis.value);

      try {
        const res = await api.post(`/api/auth/ScanColisDistr`, data);
        codeColis.value = "";

        if (res.data.message === "success") {
          // new Audio(require("@/assets/sound.mp3")).play();
          showToast("Colis est bien ajouté", "success");
          document.getElementById("scanFocus")?.focus();
          getData();
        } else if (res.data.message === "not exist") {
          // new Audio(require("@/assets/erro.mp3")).play();
          showToast("Vous ne pouvez pas l'ajouter", "error");
        } else if (res.data.message === "parcel exit") {
          // new Audio(require("@/assets/erro.mp3")).play();
          showToast("Colis déjà existe dans ce bon !", "error");
        }
      } catch {
        showToast("Something went wrong! Veuillez réessayer", "error");
      }
    }

    async function addNewColis() {
      console.log(selectedRows);
      try {
        if (!selectedRows.value.length) {
          showToast("Veuillez sélectionner des lignes", "error");
          return;
        }

        const data = new FormData();
        data.append("UserID", String(user?.id));
        data.append("colis", JSON.stringify(selectedRows.value));
        data.append(
          "note_ref",
          Array.isArray(route.params.refNote)
            ? route.params.refNote[0]
            : String(route.params.refNote)
        );

        load_add.value = true;
        const res = await api.post(`/api/auth/ColisToDistr`, data);
        load_add.value = false;

        if (
          res.data.message === "success" &&
          res.data.errors &&
          res.data.errors.length == 0
        ) {
          // Play audio
          // const audio = new Audio("/src/assets/sound.mp3");
          // audio.play();

          showToast("Ajoutées avec succès", "success");
          getData(); // refresh data
        } else {
          // const audio = new Audio("/src/assets/erro.mp3");
          // audio.play();
          showToast("Erreur lors de l’ajout", "error");
        }
      } catch (error) {
        console.error(error);
        showToast("Une erreur est survenue, veuillez réessayer", "error");
      }
    }

    async function removeNewColis() {
      try {
        if (!selectedNewRows.value.length) {
          // show toast if no selection
          showToast("Veuillez sélectionner des lignes", "error");
          return;
        }

        const data = new FormData();
        data.append("UserID", user?.id);
        data.append("colis", JSON.stringify(selectedNewRows.value));
        data.append(
          "note_ref",
          Array.isArray(route.params.refNote)
            ? route.params.refNote[0]
            : String(route.params.refNote)
        );
        load_remove.value = true;

        const res = await api.post(`/api/auth/RemoveColisDistr`, data);
        load_remove.value = false;

        if (
          res.data.message === "success" &&
          res.data.errors &&
          res.data.errors.length == 0
        ) {
          // const audio = new Audio("/src/assets/sound.mp3");
          // audio.play();

          showToast("Supprimées avec succès", "success");
          getData(); // refresh table data
        } else {
          // const audio = new Audio("/src/assets/erro.mp3");
          // audio.play();
          showToast("Une erreur est survenue, veuillez réessayer", "error");
        }
      } catch (error) {
        console.error(error);
        showToast("Une erreur est survenue, veuillez réessayer", "error");
      }
    }

    // Lifecycle
    onMounted(async () => {
      try {
        const res = await api.get(`/api/auth/fetchStatus`);
        if (res.data) {
          StatusList.value = res.data;
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
      await getData();
    });

    function removeFilter() {
      users1.searchStatut = users1.searchLiv = "";
      status_filter.id = "";
      status_filter.name = "";
      status_filter.code = "";
      liv_filter.id = "";
      liv_filter.name = "";
      getRows1();
    }
    function searchFilter() {
      users1.searchStatut = status_filter.code;
      users1.searchLiv = liv_filter.id;
      users1.current_page = 1;
      getRows1();
    }

    return {
      isLoader,
      searchTerm1,
      searchTerm2,
      pageLength,
      pageLength2,
      columns,
      columns2,
      fields,
      selectedRows,
      selectedNewRows,
      codeColis,
      refReception,
      rows1,
      rows2,
      distribution,
      ColiDetails,
      city,
      rowID,
      row,
      users1,
      users2,
      form,
      getDate,
      resolveUserStatusVariant,
      onSelectAll,
      selectionChanged,
      onSelectAllColis,
      selectionChangedColis,
      getData,
      getRows1,
      getRows2,
      SearchColis,
      globalStore,

      status_filter,
      StatusList,
      LivreurList,
      liv_filter,
      auth,
      searchFilter,
      removeFilter,
      load_remove,
      load_add,
      addNewColis,
      removeNewColis,
    };
  },
};
</script>
